import { ChangeDetectionStrategy, Component, computed, input, linkedSignal, output } from "@angular/core";
import { IButtonDirective, IIconComponent, ITooltipDirective } from "@front/m19-ui";
import { TranslocoDirective } from "@jsverse/transloco";
import { FileMetadata } from "@m19-board/services/bulk-upload/bulk-upload-context.service";

@Component({
  selector: "app-bulk-upload-file",
  templateUrl: "./bulk-upload-file.component.html",
  imports: [IButtonDirective, IIconComponent, ITooltipDirective, TranslocoDirective],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BulkUploadFileComponent {
  public readonly fileMetadata = input.required<FileMetadata | null | undefined>();

  removeFile = output<void>();
  upload = output<File>();
  uploadPlainText = output<string>();
  preview = output<void>();
  export = output<void>();

  private readonly trimmedTextareaValue = computed(() => this.textareaValue()?.trim());

  readonly canPreview = computed(() => this.trimmedTextareaValue() !== "" || !!this.fileMetadata());
  readonly isPlainText = computed(() => this.fileMetadata()?.type === "text/plain");

  textareaValue = linkedSignal(() => (this.isPlainText() ? this.fileMetadata()?.rows.join("\n") : ""));

  textareaInputChange(event: Event) {
    this.textareaValue.set((event.target as HTMLTextAreaElement).value);
  }

  emitPreview() {
    if (this.trimmedTextareaValue() !== "") {
      this.emitUploadPlainText();
    } else if (this.fileMetadata() !== null) {
      this.preview.emit();
    }
  }

  uploadFile(event: Event) {
    const file: File | undefined = (event.target as HTMLInputElement).files?.[0];
    if (!file) return;
    this.upload.emit(file);
  }

  emitUploadPlainText() {
    if (!this.trimmedTextareaValue()) return;
    this.uploadPlainText.emit(this.trimmedTextareaValue()!);
  }
}
